import React, { FC, memo, ReactNode } from "react";
import { IconType } from "react-icons";

type Props = React.DetailedHTMLProps<
  React.InputHTMLAttributes<HTMLInputElement>,
  HTMLInputElement
> & {
  register?: any;
  ContainerClassName?: string;
  showDimensions?: boolean;
  IconProp?: ReactNode;
  Icon?: IconType;
  error?: string;
  value?: string;
  label: string;
};

const NumericInput: FC<Props> = ({
  Icon,
  error,
  label,
  IconProp,
  ContainerClassName,
  register,
  ...rest
}) => (
  <div key={label} className={"overflow-hidden w-full " + ContainerClassName}>
    <label className="text-gray-400 capitalize">{label}</label>
    <div className="border rounded-md mt-1">
      <input
        {...rest}
        {...register}
        className={
          "flex-1 outline-none px-4 py-3 rounded-md w-full " + rest.className
        }
        min={0}
      />
    </div>
  </div>
);

export default memo(NumericInput);
